import React, {FC, Fragment} from "react";
import {MenuItem, Select as DefaultSelect} from "@mui/material";
import styled from "@emotion/styled";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {PagePreloader} from "views/components/preloader";
import {ILanguageSelectController} from "./language_select.controller";

const Select = styled(DefaultSelect)`
	background: transparent;
	color: inherit;

	&&& fieldset {
		border-color: transparent;
		border-width: 1px;
	}

	&:focus {
		background: transparent;
		color: #ffffff;
	}

	svg {
		color: inherit;
	}

	.MuiSelect-select {
		padding-left: 4px;
	}
`;

export const LanguageSelect: FC = observer(() => {
	const {languages, i18n, handleChange, isLoading} = useViewController<ILanguageSelectController>(
		Bindings.LanguageSelectController
	);

	if (!languages.length) {
		return null;
	}

	return (
		<Fragment>
			<Select
				labelId="demo-simple-select-label"
				id="demo-simple-select"
				value={i18n.locale}
				onChange={handleChange}>
				{languages.map(({locale, lang}) => (
					<MenuItem value={locale} key={locale}>
						{i18n.t(`header.langs.${lang}`)}
					</MenuItem>
				))}
			</Select>

			{isLoading && <PagePreloader />}
		</Fragment>
	);
});
